import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VisionNews.css";

const VisionNews = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios.get("https://bihanichildrensacademy.com/api/news")
      .then(res => setNews(res.data))
      .catch(err => console.log(err));
  }, []);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  return (
    <section className="vision-news-section">
      <div className="vision-news-container">

        {/* LEFT SIDE */}
        <div className="vision-left">
          <h2>OUR VISION & MISSION</h2>

          <p>
            The mission of Bihani Childrens Academy is to prepare children for
            the future by providing knowledge and skills to achieve academic
            excellence, confidence, personal growth and success in a safe,
            positive and diverse environment and to be responsible and
            productive citizens.
          </p>

          <p>
            Our mission is to provide a vibrant forum for quality education,
            with a scientific temper, adaptive to the changing needs of time,
            to ensure all round development of the child and to give an
            exposure to a wide spectrum of co cultural learning which is
            essential to make the child confident.
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="news-right">
          <h3>LATEST NEWS</h3>

          <div className="news-scroll">
            {news.map((item) => (
              <div className="news-item" key={item.id}>
                <span className="news-date">
                  {formatDate(item.news_date)}
                </span>
                <span className="news-text">
                  {item.title}
                </span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default VisionNews;
